import React, { Context } from 'react';
import { PageProps } from '../components/component-switcher';
import { AppContext, AppContextInterface } from '../app-context-provider';
import { ReactComponent as ArrowDown } from '../assets/images/Arrow-Down.svg';
import { Swipeable, EventData } from 'react-swipeable';

export interface PageHeaderProps extends PageProps {
  pageBodyRef: React.RefObject<HTMLDivElement>;
}

export interface PageHeaderState {
  hovering: boolean;
}

class PageHeader extends React.Component<PageHeaderProps, PageHeaderState> {
  static contextType: Context<AppContextInterface | null> = AppContext;
  context!: AppContextInterface;
  state: PageHeaderState = {
    hovering: false,
  };

  constructor(props: PageHeaderProps) {
    super(props);
    this.mouseEnter = this.mouseEnter.bind(this);
    this.mouseLeave = this.mouseLeave.bind(this);
    this.mouseMove = this.mouseMove.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  mouseEnter() {
    this.setState({ hovering: true });
  }

  mouseLeave() {
    this.setState({ hovering: false });
  }
  mouseMove() {
    if (!this.state.hovering) {
      this.setState({ hovering: true });
    }
  }
  onClick() {
    // if (this.props.BodyRef === null) {
    //     return;
    // }
    // scrollTo(this.propsBodyRef, 300);
  }

  onSwipe(e: EventData) {
    // if (e.dir === "Up") {
    //     scrollTo(this.propsBodyRef, 300);
    // }
    // if (e.dir === "Left") {
    //     this.props.history.push(this.props.nextPage.url);
    //     scrollToTop();
    // }
    // if (e.dir === "Right") {
    //     this.props.history.push(this.props.prevPage.url);
    //     scrollToTop();
    // }
  }

  renderHeaderButton() {
    // let nextLink = this.props.nextPage ? this.props.nextPage.url : '/';
    // let nextLinkText = this.props.nextPage ? this.props.nextPage.name : 'Home';

    // let buttonText = `Go to ${nextLinkText}`;
    // let buttonIcon = <Arrow />
    // if (this.props?.data === null || this.props?.data?.children?.length === 0) {
    //     return (
    //         <SolidIconLink iconStyle={{ fill: 'white', stroke: 'white' }} hoverText="Let's go!" fontSize="19px" buttonText={buttonText} icon={buttonIcon} link={nextLink} />
    //     );
    // }

    return (
      <button className='scroll-button' onClick={this.onClick}>
        <ArrowDown />
        <span className='link-text'>
          <span>Go to&nbsp;</span>
          <span className='bold-text'>{this.props.title}</span>
        </span>
      </button>
    );
  }

  render() {
    let h1Style = { color: this.context.styles?.bodyText.dark };
    let h2Style = { color: this.context.styles?.bodyText.vibrant };
    let descrpitionStyle = { color: this.context.styles?.bodyText.dark };

    return (
      <Swipeable
        preventDefaultTouchmoveEvent={true}
        onSwiped={this.onSwipe.bind(this)}
        className='page-header'>
        <h1 style={h1Style}>{this.props.title}</h1>
        <h2 style={h2Style}>{this.props.subtitle}</h2>
        <p
          style={descrpitionStyle}
          dangerouslySetInnerHTML={{ __html: this.props.description }}
        />
        {this.renderHeaderButton()}
      </Swipeable>
    );
  }
}

export default PageHeader;
